document.addEventListener("DOMContentLoaded", function () {
  const selectors = {
    inputRange: ".custom-range input[type='range']",
    pricingCalcSwiper: ".pricing-calc-swiper",
    pricesCC: ".prices_cc",
    section: ".section--calculator-pricing",
  };

  const range = document.querySelector(selectors.inputRange);
  const pricingCalcSwiper = document.querySelector(selectors.pricingCalcSwiper);
  const section = document.querySelector(selectors.section);

  function updateSliderBackground() {
    const min = range.min;
    const max = range.max;
    const val = range.value;

    // Calculate the percentage value
    const percentage = ((val - min) / (max - min)) * 100;

    // Apply the gradient
    range.style.background = `linear-gradient(to right, #4d6964 ${percentage}%, #ccd7c5 ${percentage}%)`;
  }

  window.recalculate = function () {
    const variant = pricingCalcSwiper.querySelector(".swiper-slide.selected")
      .dataset.varianti;
    let inputValue = range.value;

    const price = section.querySelector(
      `.prices_cc span[data-i="${inputValue}"][data-v="${variant}"]`
    ).dataset.p;
    section.querySelector("#q__calc").textContent = `USD $${price}`;
  };

  // Initial update
  updateSliderBackground();
  window.recalculate();

  const handleRangeChange = function () {
    updateSliderBackground();
    window.recalculate();
  };

  document.addEventListener("shopify:section:select", function (event) {
    updateSliderBackground();
    window.recalculate();
  });

  // Update background on input
  range.addEventListener("input", handleRangeChange);
});

// $(document).ready(function () {
//   window.recalculate = function () {
//     var varinat = $(".swiper-slide.selected").data("varianti");
//     var inputv = $(".single-slider").val();
//     var pp_p = $(
//       '.prices_cc span[data-i="' + inputv + '"][data-v="' + varinat + '"]'
//     ).data("p");
//     $("#q__calc").text("USD $" + pp_p);
//   };
//   $(".single-slider").jRange({
//     from: 1,
//     to: 5,
//     step: 1,
//     scale: [25, 50, 100, 500, 1000],
//     format: "%s",
//     showLabels: false,
//     snap: true,
//     onstatechange: window.recalculate,
//   });

//   window.recalculate();
//   document.addEventListener("shopify:section:select", function (event) {
//     window.recalculate();
//   });
// });
